import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppUrls } from '../../route/app-urls';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private http = inject(HttpClient);

  public getManual(): Observable<Blob> {
    return this.http.get(AppUrls.getApiUrl(AppUrls.urlDocument, 'getmanual'), {
      responseType: 'blob'
    });
  }
}
